import * as R from 'ramda';
import { IPerson } from 'global';
import { alpha } from 'utils/color';
import intl from 'react-intl-universal';
import { navigatorTo } from 'utils/util';
import { IComponentLink } from 'component';
import { IJigsaw } from 'store/GalleryStore';
import React, { useEffect, useState } from 'react';
import { decodeFaceUrl, style } from 'utils/image';
import { CloseAnimation } from 'components/GalleryList/GalleryListWrapper';

import Button from '../Common/Button';
import useTheme from '../hooks/useTheme';
import RootStore from '../../store/RootStore';
import SimpleBigPic from '../BigPic/SimpleBigPic';
import { IOneGallery } from '../GalleryList/Common';
import useSimpleBigPic from '../BigPic/useSimpleBigPic';
import AllForColumn2 from '../GalleryList/AllForColumn2';
import wxUtil, { getQueryShareData } from '../../utils/wx';

import './FolloweeDetail.scss';

const { getTitle, getShareUrl, getShareImage, getShareText } = wxUtil;

export interface IFolloweeDetail {
  person: IPerson;
  personAlbum: any;
  followeeList?: any[];
  onClickPerson?: (id: string, imageid?: string) => void;
  onBack?: () => void;
  onFollow?: (person: IPerson) => void;
  onUnfollow?: (person: IPerson) => void;
  onShowShare?: (id: number | string) => void;
  jigsaw?: IJigsaw;
  setJigsaw?: (obj: IJigsaw) => void;
  rootStore?: RootStore;
  showCurrentGallery?: boolean;
}

export const GalleryWrapper = (props: {
  data: any;
  type?: string;
  info?: any;
  galleryId?: string | number;
  jigsaw?: IJigsaw;
  setJigsaw?: (obj: IJigsaw) => void;
  rootStore?: RootStore;
}) => {
  const { jigsaw, setJigsaw } = props;
  const { list, columnsClick, setBigIndex, bigIndex, loadBigPic, loadFinish } =
    useSimpleBigPic(props.data, undefined, props.type);
  const { h1Color, mainColor } = useTheme();

  const checkToPay = (galleryid: string | number, id: number) => {
    let targetGallery =
      props.rootStore!.pagedataStore.currentGallerys[String(galleryid)];

    if (
      typeof targetGallery != 'undefined' &&
      Number(targetGallery.is_pay_down) > 0
    ) {
      // 检查一下是否已经支付完成了
      let notPayed = props.rootStore!.wxuserStore.getNotPayed([Number(id)]);

      if (notPayed && notPayed.length) {
        // 这是一个需要付费的子相册里的照片，不让选择
        // 或者
        // 直接去请求付费
        return props
          .rootStore!.wxuserStore.payToImage(
            galleryid,
            Number(targetGallery.is_pay_down),
            window.pageDetail.link_id,
            [Number(id)]
          )
          .then(() => {});
      }
    } else {
      props.rootStore!.wxuserStore.setNotNeedToPay(id, true);
    }

    return null;
  };

  const onImageClick = ({
    index,
    id,
    galleryid,
  }: {
    galleryid?: string | number;
    index?: number;
    id: number;
  }) => {
    if (jigsaw && jigsaw.bottomShow) {
      //   this.setJigsawList(realIndex);
      let jigsawList = jigsaw.jigsawList;
      let existIndex = jigsawList.findIndex(
        (it: IOneGallery) => Number(it.id) == Number(id)
      );

      if (existIndex > -1) {
        jigsawList = jigsawList.filter((it: IOneGallery, ind: number) => {
          return ind != existIndex;
        });
      } else {
        // 检测一下当前照片，是否来源于付费相册
        if (typeof galleryid != 'undefined') {
          let checkResult = checkToPay(galleryid, id);
          if (checkResult) {
            return;
          }
        }

        let one = list.find((item: IOneGallery) => Number(item.id) == id);
        if (one) {
          jigsawList = [...jigsawList, one];
        }
      }

      if (setJigsaw) {
        setJigsaw({
          jigsawList,
        } as IJigsaw);
      }
    } else {
      if (typeof galleryid != 'undefined') {
        let checkResult = checkToPay(galleryid, id);
        if (checkResult) {
          return;
        }
      }
      columnsClick({ index, id });
    }
  };

  //  第二层: 这儿这样做的目的是为了在currentPropIndex变化时，不会立即关闭大图, 给页面一定的动画时间
  const [current, setCurrent] = useState(bigIndex);
  useEffect(() => {
    if (bigIndex === -1) {
      const timer = setTimeout(() => {
        setCurrent(bigIndex);
      }, 10);
      return () => clearTimeout(timer);
    } else {
      const timer = setTimeout(() => {
        setCurrent(bigIndex);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [bigIndex]);

  return (
    <div className="list-content-wrapper">
      {!!props.info ? (
        <div className="list-content-wrapper-title" style={{ color: h1Color }}>
          {props.info.name}
          <a
            style={{ color: mainColor }}
            onClick={() => {
              if (props.galleryId) {
                navigatorTo({
                  type: 'gallery',
                  value: String(props.galleryId),
                  link_id: props.info.link,
                } as IComponentLink);
              }
            }}
          >
            {intl.get('Go')}
          </a>
        </div>
      ) : null}
      <div className="gallery-list">
        <AllForColumn2
          current={bigIndex}
          list={list}
          onClick={onImageClick}
          jigsaw={jigsaw}
        />
        <CloseAnimation
          containerSelectorFunction={() => {
            return '.followee-detail';
          }}
          targetElementSelectorFunction={(item: any) => {
            return `.img-wrapper[data-id="${item.id}"]`;
          }}
          list={list}
          index={bigIndex}
        />
      </div>
      <SimpleBigPic
        pageType="MyPhoto"
        index={current}
        list={list}
        setIndex={setBigIndex}
        loadBigPic={loadBigPic}
        loadFinish={loadFinish}
      />
    </div>
  );
};

const Index = (props: IFolloweeDetail) => {
  //  获取是否开启了微信授权 window.configDetail.active_on
  const wechatShareIsOn = R.pathEq(1, ['configDetail', 'active_on'], window);

  //  判断如果是在landing页并且有头像的情况下，使用头像
  const isLandingPage = window.location.pathname.indexOf('person') > -1;
  const query = new URLSearchParams(window.location.search);
  const avatar = query.get('avatar') as string;
  const hasAvatar = avatar && avatar.length > 0;

  const {
    person,
    personAlbum,
    onFollow,
    onUnfollow,
    onShowShare,
    jigsaw,
    setJigsaw,
  } = props;
  const { backgroundColor, h1Color, h2Color } = useTheme();

  const decoder =
    person && person.faceurl ? decodeFaceUrl(person.faceurl) : null;

  const album =
    personAlbum && personAlbum.data && Object.keys(personAlbum.data).length
      ? Object.keys(personAlbum.data)
      : [];

  const current = album.filter(
    (key: string) => key == String(window.gallery.id)
  );
  const history = album
    .filter((key: string) => key != String(window.gallery.id))
    .sort((a: string, b: string) => {
      return Number(a) > Number(b) ? -1 : 1;
    });

  useEffect(() => {
    let oldLink = window.location.href;
    if (person && person.id) {
      const shareQuery = getQueryShareData();
      wxUtil.configPersonShare(person.id, {
        image: shareQuery.i,
        title: shareQuery.t,
        desc: shareQuery.d,
      });
    }

    return () => {
      if (person && person.id) {
        window.history.replaceState('person', window.document.title, oldLink);
        // 设置分享

        wxUtil.configShare({
          title: getTitle(),
          image: getShareImage(),
          url: getShareUrl(),
          desc: getShareText(),
        });
      }
    };
  }, [person && person.id]);

  const currentGalleryWrapperInfo = props.showCurrentGallery
    ? {
        info: {
          name: window.gallery.name,
          link: window.gallery.link,
        },
        galleryId: window.gallery.id,
      }
    : null;

  const finalAvatar =
    avatar || (isLandingPage && hasAvatar)
      ? person.faceurl
      : style(decoder?.src, 'face', {
          shape: decoder?.shape,
          webp: true,
          fixedFilter: true,
        });

  return (
    <div
      className="followee-detail"
      style={{ backgroundColor: alpha(backgroundColor, 1) }}
    >
      <div className="followee-detail-wrapper">
        <div
          className="followee-header"
          style={{ boxShadow: `0 2px 4px 2px ${alpha(h1Color, 0.1)}` }}
        >
          <div
            className="header-avatar"
            style={{ borderColor: alpha(h1Color, 0.1) }}
          >
            {decoder ? (
              <img className="avatar-source" src={finalAvatar} />
            ) : null}
          </div>
          <div className="header-content">
            <div style={{ display: `flex` }}>
              {wechatShareIsOn && person && person.status == 'unfollow' ? (
                <Button
                  size="small"
                  radius={true}
                  onClick={() => onFollow && onFollow(person)}
                >
                  {intl.get('Add to friends')}
                </Button>
              ) : null}
              {wechatShareIsOn && person && person.status == 'follow' ? (
                <Button
                  size="small"
                  radius={true}
                  onClick={() => onUnfollow && onUnfollow(person)}
                >
                  {intl.get('Unfollow')}
                </Button>
              ) : null}
              <div style={{ marginLeft: 10 }}>
                <Button
                  size="small"
                  radius={true}
                  onClick={() => {
                    if (onShowShare) {
                      onShowShare(person.id);
                    }
                  }}
                >
                  {intl.get('ClickShare')}
                </Button>
              </div>
            </div>
            <div className="total-info">
              <div className="info-field" style={{ color: h2Color }}>
                {intl.get('current album')}
                <span className="imp" style={{ color: h1Color }}>
                  {person.total_image}
                </span>
                {intl.get('photos', {
                  num: person.total_image,
                })}
              </div>
              <div className="info-field" style={{ color: h2Color }}>
                {intl.get('History album')}
                <span className="imp" style={{ color: h1Color }}>
                  {person.total_gallery_image - person.total_image}
                </span>
                {intl.get('photos', {
                  num: person.total_gallery_image - person.total_image,
                })}
              </div>
            </div>
          </div>
        </div>
        <div className="list-wrapper">
          <div className="list-header" style={{ color: h1Color }}>
            {`${intl.get('CurrentGalleryPhoto')}`}
            <span className="smaller" style={{ color: h2Color }}>{`（${
              person.total_image
            }${intl.get('photos', {
              num: person.total_image,
            })}）`}</span>
          </div>
          <div className="list-content">
            {current && current.length > 0 ? (
              <GalleryWrapper
                data={personAlbum.data}
                {...currentGalleryWrapperInfo}
                type="current"
                jigsaw={jigsaw}
                setJigsaw={setJigsaw}
                rootStore={props.rootStore}
              />
            ) : (
              <div className="list-content-empty" style={{ color: h2Color }}>
                {intl.get('NoMatchPhoto')}
              </div>
            )}
          </div>
        </div>
        <div className="list-wrapper">
          <div className="list-header" style={{ color: h1Color }}>
            {`${intl.get('HistoryGalleryPhoto')}`}
            <span className="smaller" style={{ color: h2Color }}>{`（${
              person.total_gallery_image - person.total_image
            } ${intl.get('photos', {
              num: person.total_gallery_image - person.total_image,
            })}）`}</span>
          </div>
          <div className="list-content">
            {history && history.length > 0 ? (
              history.map((key: string) => {
                const target = personAlbum.data[key];
                const result = {
                  [key]: target,
                };
                return (
                  <GalleryWrapper
                    key={key}
                    data={result}
                    type="history"
                    info={target}
                    galleryId={key}
                    jigsaw={jigsaw}
                    setJigsaw={setJigsaw}
                    rootStore={props.rootStore}
                  />
                );
              })
            ) : (
              <div className="list-content-empty" style={{ color: h2Color }}>
                {intl.get('NoMatchPhoto')}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
